var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_275_111)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_275_111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 0H2.66667C1.19391 0 0 1.19391 0 2.66667V13.3333C0 14.8061 1.19391 16 2.66667 16H13.3333C14.8061 16 16 14.8061 16 13.3333V2.66667C16 1.19391 14.8061 0 13.3333 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 5.56597L12 7.17033C11.1822 7.17033 10.4243 6.90413 9.8058 6.45241V9.71327C9.8058 11.3418 8.50353 12.6667 6.90287 12.6667C6.28432 12.6667 5.71073 12.4682 5.23925 12.1314L5.23844 12.1305C4.49029 11.5958 4 10.7118 4 9.71293C4 8.08447 5.30222 6.75953 6.90293 6.75953C7.03573 6.75953 7.16593 6.77067 7.29413 6.78833L7.29407 8.42673C7.1702 8.38733 7.03933 8.3644 6.90287 8.3644C6.17183 8.3644 5.57712 8.96953 5.57712 9.71327C5.57712 10.2311 5.86593 10.6811 6.28791 10.9071C6.47189 11.0056 6.68087 11.0621 6.9028 11.0621C7.61693 11.0621 8.19953 10.4841 8.22607 9.764L8.22853 3.33333H9.80573C9.80573 4.59652 10.8257 5.56597 11.9999 5.56597Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_275_111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 3,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_275_111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.3351f24b3c032e47c39a771f7cf6c36a.svg";
export { ForwardRef as ReactComponent };